import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { peerReviewTypeList } from '@/module/Publisher';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type PeerReviewSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

export function PeerReviewSelectControl<T extends FieldValues>(props: PeerReviewSelectControlProps<T>) {
  const { t } = useTranslation();
  const peerReviewOptions = peerReviewTypeList.map(c => ({ value: c, label: t(`publishers.peerReviewEnum.${c}`) }));
  return (
    <EnumSelectControl
      {...props}
      options={peerReviewOptions}
    />
  );
}
